import React from 'react';
import styles from './OrderManagement.module.scss';
import { Button, Col, Row } from 'reactstrap';
import { utils, writeFile } from 'xlsx';
import ManageTable from '../../../../../Manage/ManageTable';

const data = [
    {
        id: 1,
        orderId: '367658',
        customerName: 'John Deep',
        date: '11/07/2024',
        amount: '$40',
        warehouse: 'Warehouse 1',
        status: 'Processing',
    },
    {
        id: 2,
        orderId: '367658',
        customerName: 'John Deep',
        date: '11/07/2024',
        amount: '$40',
        warehouse: 'Warehouse 1',
        status: 'Processing',
    },
    {
        id: 3,
        orderId: '367658',
        customerName: 'John Deep',
        date: '11/07/2024',
        amount: '$40',
        warehouse: 'Warehouse 1',
        status: 'Processing',
    },
    {
        id: 4,
        orderId: '367658',
        customerName: 'John Deep',
        date: '11/07/2024',
        amount: '$40',
        warehouse: 'Warehouse 1',
        status: 'Processing',
    },
];

const columns = [
    {
        name: 'Order ID',
        selector: (row) => row.orderId,
        sortable: true,
        minWidth: "120px",
    },
    {
        name: 'Customer name',
        selector: (row) => row.customerName,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: 'Order Date',
        selector: (row) => row.date,
        sortable: true,
        minWidth: "140px",
    },
    {
        name: 'Total Amount',
        selector: (row) => row.amount,
        sortable: true,
        minWidth: "140px",
    },
    {
        name: 'Warehouse',
        selector: (row) => row.warehouse,
        sortable: true,
        minWidth: "120px",
    },
    {
        name: 'Status',
        selector: (row) => row.status,
        sortable: true,
        minWidth: "120px",
    },
    {
        name: 'Action',
    },
];

const OrderManagement = () => {

    const handlePrint = () => {
        window.print();
    };

    const handleExportExcel = () => {
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'Products');
        writeFile(workbook, 'ManagePlatformProducts.xlsx');
    };

    return (
        <div className={styles.mainManageProductsContainer}>
            <h4 className={styles.sectionHeading}>Order Management</h4>

            <div className={styles.manageProducts}>
                <Row className={styles.totalProducts}>
                    <Col lg={"auto"} className={styles.totalProductsContainer}>
                        <span>Total Products: 300</span>
                    </Col>
                    <Col lg={"auto"} className={styles.btnsContainer}>
                        <Button type="button" onClick={handlePrint}>
                            Print
                        </Button>
                        <Button type="button" onClick={handleExportExcel}>
                            Export
                        </Button>
                    </Col>
                </Row>

                <ManageTable
                    name={'Order Management'}
                    columns={columns}
                    tableData={data}
                />
            </div>
        </div>
    )
}

export default OrderManagement;